import Link from "@tiptap/extension-link";
import EditableImage from "@/tiptap/extensions/editable-image/editable-image";
import Video from "@/tiptap/extensions/video/video";
import Audio from "@/tiptap/extensions/audio/audio";
import Placeholder from "@tiptap/extension-placeholder";
import TextAlign from "@tiptap/extension-text-align";
import StarterKit from "@tiptap/starter-kit";
import i18n from "@/i18n";
import Info from "@/tiptap/extensions/info/info";

export default [
  StarterKit,
  TextAlign.configure({
    types: ["heading", "paragraph", "image"],
  }),
  Link.configure({
    openOnClick: false,
  }),
  EditableImage,
  Video,
  Audio,
  Info,
  Placeholder.configure({ placeholder: i18n.t("chapter.placeholder") }),
];